import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class PricebookEntryService extends DatabaseGwService {
  URL_PATH: string = '/pricebook-entries';

  
}
